var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "560",
      "persistent": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_vm.isLoaded ? _c('v-card', {
    attrs: {
      "height": "100%"
    }
  }, [_c('v-card-title', [_vm.isCreate ? [_vm._v("작가 생성")] : [_vm._v("작가 상세")], _c('v-spacer'), _c('v-icon', {
    on: {
      "click": function click($event) {
        _vm.shows = false;
      }
    }
  }, [_vm._v("mdi-close")])], 2), _c('v-divider'), _c('v-card-text', {
    staticClass: "pa-0",
    staticStyle: {
      "max-height": "calc(90vh - 120px)",
      "overflow-y": "auto"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', [_c('v-card-subtitle', [_vm._v("기본 정보")]), _c('v-divider'), _c('v-card-text', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "mr-3"
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "국가(국문)"
    },
    model: {
      value: _vm.inputs.country.ko,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs.country, "ko", $$v);
      },
      expression: "inputs.country.ko"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "label": "국가(영문)"
    },
    model: {
      value: _vm.inputs.country.en,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs.country, "en", $$v);
      },
      expression: "inputs.country.en"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1)], 1), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "mr-3"
  }, [_c('v-text-field', _vm._b({
    staticClass: "my-3",
    attrs: {
      "label": "이름(국문)"
    },
    model: {
      value: _vm.inputs.name.ko,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs.name, "ko", $$v);
      },
      expression: "inputs.name.ko"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', [_c('v-text-field', _vm._b({
    staticClass: "my-3",
    attrs: {
      "label": "이름(영문)"
    },
    model: {
      value: _vm.inputs.name.en,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs.name, "en", $$v);
      },
      expression: "inputs.name.en"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1)], 1), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "mr-3"
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "생년월일",
      "type": "date",
      "clearable": ""
    },
    model: {
      value: _vm.inputs.bornAt,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "bornAt", $$v);
      },
      expression: "inputs.bornAt"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "label": "생몰월일",
      "type": "date",
      "clearable": ""
    },
    model: {
      value: _vm.inputs.diedAt,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "diedAt", $$v);
      },
      expression: "inputs.diedAt"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1)], 1), _c('v-textarea', _vm._b({
    staticClass: "mt-3",
    attrs: {
      "label": "설명",
      "auto-grow": ""
    },
    model: {
      value: _vm.inputs.content,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "content", $$v);
      },
      expression: "inputs.content"
    }
  }, 'v-textarea', _vm.attrs_input, false))], 1)], 1)], 1)], 1), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "large": "",
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(" 저장하기 ")])], 1)], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }